/**
 * Internationalization wrapper for Web (Next.js) and Desktop (Electron)
 *
 * This file is resolved by Webpack for web builds.
 * All i18n imports should come from "@shared/utils/internationalization"
 */
import { Trans, useTranslation } from "next-i18next";

export { Trans, useTranslation };

// Note: appWithTranslation is intentionally NOT re-exported here.
// It's a Next.js-specific HOC that doesn't work in Storybook.
// Import it directly from "next-i18next" where needed (e.g., _app.tsx).

// Re-export types from i18next for consistent imports
export type { TFunction } from "i18next";

// If translation must happen on the server side,
// Include this object type with the interpolated text
// And pass it to the t() function when the component is rendered
//
// Example string: "{{cityName}} is a cool city."
// Example object: interpolation: { cityName: "Some city" }
export type ServersidePropInterpolation = {
  interpolation: { [key: string]: string };
};

/**
 * DUMMY TRANSLATION FUNCTION
 *
 * This is so that the i18next-parser can parse the t() calls in the next-app.
 * You would only use this if you are in an area of the codebase that does not support hooks, but would
 * still like the i18next-parser to parse the t() calls.
 *
 * At runtime, if this function is used directly it will NOT translate the input.
 * @param input
 * @returns input
 */
export const t = (
  input: string,
  _?: { [key: string]: number | string } // eslint-disable-line @typescript-eslint/no-unused-vars
): string => input;

export const supportedLocales: string[] = ["en", "fr"];
